import { actionClient } from '@/api'

export default {

  namespaced: true,

  state: {

  },


  mutations: {

  },

  actions: {

    async send({ commit }, data) {
      await actionClient.post('mail-code', data)
    },

    async mobileSend({ commit }, data) {
      await actionClient.post('mobile-code', data)
    }
  }


}
